import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';

export interface ReportSubmission {
  id: string;
  client_id: string;
  report_type: 'Initial' | 'Review';
  [key: string]: any;
}

/**
 * Fetches all report submissions (Initial and Review) for a given client.
 * @param clientId string
 * @returns Promise<ReportSubmission[]>
 */
export async function getClientReportSubmissions(clientId: string): Promise<ReportSubmission[]> {
  try {
    const initialRef = collection(db, 'report_submissions', clientId, 'Initial');
    const initialSnap = await getDocs(initialRef);
    const initialReports: ReportSubmission[] = initialSnap.docs.map(doc => ({
      id: doc.id,
      client_id: clientId,
      report_type: 'Initial',
      ...doc.data(),
    }));

    let reviewReports: ReportSubmission[] = [];
    try {
      const reviewRef = collection(db, 'report_submissions', clientId, 'Review');
      const reviewSnap = await getDocs(reviewRef);
      reviewReports = reviewSnap.docs.map(doc => ({
        id: doc.id,
        client_id: clientId,
        report_type: 'Review',
        ...doc.data(),
      }));
    } catch (e) {
      // No review reports, ignore
    }
    return [...initialReports, ...reviewReports];
  } catch (e) {
    return [];
  }
}
